export default "__VITE_ASSET__DMWBTPgd__"